var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 .5c5.385 0 10.26 2.183 13.789 5.711A19.439 19.439 0 0 1 39.5 20c0 5.385-2.183 10.26-5.711 13.789A19.439 19.439 0 0 1 20 39.5a19.439 19.439 0 0 1-13.789-5.711A19.439 19.439 0 0 1 .5 20c0-5.385 2.183-10.26 5.711-13.789A19.439 19.439 0 0 1 20 .5z",
    stroke: "#ECECEC",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 30.624c-5.547 0-9.167-1.63-9.167-2.82 0-.8 1.86-2.116 5.982-2.628l2.59 4.064a.705.705 0 0 0 1.19 0l2.59-4.064c4.122.512 5.982 1.828 5.982 2.628 0 1.18-3.588 2.82-9.167 2.82zm-5.112-11.097a6.327 6.327 0 0 1-1.234-3.758c0-3.526 2.84-6.393 6.346-6.393 3.5 0 6.346 2.868 6.346 6.393 0 1.316-.4 2.578-1.158 3.651-.068.09.286-.46-5.188 8.13l-5.112-8.023zm9.13 4.341c2.561-4.019 2.24-3.517 2.313-3.622a7.699 7.699 0 0 0 1.426-4.477c0-4.279-3.473-7.804-7.757-7.804-4.27 0-7.757 3.518-7.757 7.804 0 1.613.504 3.201 1.467 4.534l2.272 3.565c-2.43.374-6.56 1.486-6.56 3.936 0 .893.584 2.165 3.36 3.157 1.939.692 4.502 1.074 7.218 1.074 5.078 0 10.577-1.433 10.577-4.231 0-2.45-4.125-3.562-6.559-3.936z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.885a2.118 2.118 0 0 1-2.115-2.116c0-1.166.949-2.115 2.115-2.115 1.166 0 2.115.949 2.115 2.115A2.118 2.118 0 0 1 20 17.885zm0-5.642a3.53 3.53 0 0 0-3.526 3.526A3.53 3.53 0 0 0 20 19.295a3.53 3.53 0 0 0 3.526-3.526A3.53 3.53 0 0 0 20 12.243z",
    fill: "#3D3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.e7545d7f7cbb76aae8fc63ed07e028c4.svg";
export { ForwardRef as ReactComponent };